import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FilterFieldDatetimeComponent} from "@app/_modules/filter-fields/types/datetime/filter-field-datetime.component";
import {ReactiveFormsModule} from "@angular/forms";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  declarations: [
    FilterFieldDatetimeComponent
  ],
  exports: [
    FilterFieldDatetimeComponent

  ]
})
export class FilterFieldDatetimeModule {}
